import { useId } from "react";
import { useTranslation } from "react-i18next";
import { useScheduleStore } from "../../../stores/schedule-store";
import { Checkbox } from "../../ui/checkbox";
import { DevOverlayControls } from "./DevOverlayControls";
import { MetadataEditor } from "./MetadataEditor";

export function DeveloperSection() {
  const { t } = useTranslation();
  const id = useId();
  const enabled = useScheduleStore(state => state.developerMode);
  const setEnabled = useScheduleStore(state => state.setDeveloperMode);

  return (
    <div className="flex h-full min-h-0 flex-col gap-3">
      <div className="flex shrink-0 items-center gap-2">
        <Checkbox id={id} checked={enabled} onCheckedChange={checked => setEnabled(checked === true)} />
        <label htmlFor={id} className="text-xs font-medium">{t("developer.enable")}</label>
      </div>
      {enabled && <DevOverlayControls />}
      <MetadataEditor enabled={enabled} />
    </div>
  );
}
